import { authorizedRequestJson } from '../lib/authSession';

export function listFamilyMembers({ token }) {
  return authorizedRequestJson('/family-members');
}

export function createPassportUpload({ token, fileName, contentType }) {
  return authorizedRequestJson('/family-members/passport-upload', {
    method: 'POST',
    body: { fileName, contentType },
  });
}

export async function uploadFileToPresignedUrl({ uploadUrl, file, contentType }) {
  const response = await fetch(uploadUrl, {
    method: 'PUT',
    headers: {
      'Content-Type': contentType,
    },
    body: file,
  });

  if (!response.ok) {
    throw new Error('Passport upload failed.');
  }
}

export function parsePassportAutofill({ token, objectKey }) {
  return authorizedRequestJson('/family-members/passport-autofill', {
    method: 'POST',
    body: { objectKey },
  });
}

export function createFamilyMember({ token, member }) {
  return authorizedRequestJson('/family-members', {
    method: 'POST',
    body: member,
  });
}

export function updateFamilyMember({ token, memberId, member }) {
  return authorizedRequestJson(`/family-members/${memberId}`, {
    method: 'PUT',
    body: member,
  });
}

export function deleteFamilyMember({ token, memberId }) {
  return authorizedRequestJson(`/family-members/${memberId}`, {
    method: 'DELETE',
  });
}
